import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/lib/context";

export default function AuthCallback() {
  const { setUser } = useAuth();
  const nav = useNavigate();
  const location = useLocation();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    const role = localStorage.getItem("gst_signup_role") || undefined;
    localStorage.removeItem("gst_signup_role");
    api.post("/auth/google/session", { session_id: sid, role })
      .then(({ data }) => {
        if (data.mfa_token) { sessionStorage.setItem("gst_mfa", JSON.stringify(data)); setUser(false); nav("/login", { replace: true }); return; }
        setUser(data); nav("/", { replace: true });
      })
      .catch((e) => { toast.error(errMsg(e)); setUser(false); nav("/login", { replace: true }); });
  }, [location.hash, nav, setUser]);
  return null;
}
